import rules from "@/utils/formRules/rules";
export default {
  data () {
    return {
      formRules: { // 表单验证规则

        schoolGrade: [{
          required: true,
          message: '请选择学校等级',
          trigger: 'change'
        }],
        squadGender: [{
          required: true,
          message: '请选择球队性别',
          trigger: 'change'
        }],
        schoolName: [{
          required: true,
          message: '请填写学校名称',
          trigger: 'blur'
        }],
        cooperationStartDate: [{
          required: true,
          message: '请选择合作开始时间',
          trigger: 'change'
        }],
        cooperationEndDate: [{
          required: true,
          message: '请选择合作截止时间',
          trigger: 'change'
        }],
        playerTeamNum: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value && value !==0) {
              callback(new Error('请填写在校球员人数'))
            } else {
              if (rules.isNumber(value)) {
                callback()
              } else {
                callback(new Error('请输入大于等于0的数字'))
              }
            }
          },
          trigger: 'blur'
        }],
        playerTrainNum: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value && value !==0) {
              callback(new Error('请填写合作学校每周训练次数'))
            } else {
              if (rules.isNumber(value)) {
                callback()
              } else {
                callback(new Error('请输入大于等于0的数字'))
              }
            }
          },
          trigger: 'blur'
        }],
        youthUuid: [{ required: true, message: '请选择精英机构', trigger: 'change' }],
        organUuid: [{ required: true, message: '请选择管理单位', trigger: 'change' }],

      },
    }
  }
}
